import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useTabClassName } from './utils';
import { TabLabel, TabTagWrapper, TabRoot } from './style';
import { tabDefaultTheme } from './theme';
import { TAB_CLASS_PREFIX } from './constants';
import { useTab } from './hooks/useTab';
export var Tab = forwardRef(function Tab(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TAB_CLASS_PREFIX, tabDefaultTheme);

  var _useTab = useTab(restProps, ref),
      rootProps = _useTab.rootProps,
      tagProps = _useTab.tagProps,
      tabLabelProps = _useTab.tabLabelProps,
      disabled = _useTab.disabled,
      isActive = _useTab.isActive,
      Tag = _useTab.Tag,
      label = _useTab.label,
      children = _useTab.children;

  var classOverride = useTabClassName(TAB_CLASS_PREFIX, className, disabled, isActive);
  return React.createElement(TabRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), React.createElement(TabTagWrapper, Object.assign({}, tagProps, {
    className: classOverride.Tag,
    theme: theme
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps), React.createElement(TabLabel, Object.assign({}, tabLabelProps, {
      theme: theme,
      className: classOverride.Label,
      large: true,
      label: true
    }), label || children));
  }));
});
Tab.displayName = TAB_CLASS_PREFIX;
Tab.defaultProps = {
  disabled: false
};